import styled from 'styled-components';

export const SectionAddressWrapper = styled.div`
  padding: 12px 12px;
  text-transform: capitalize;
  border: 1px solid #a8cbe2;
  border-radius: 8px;
  background-color: #f7fafb;

  p {
    color: #161d1f;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;

    > span {
      color: #4f6168;
    }

    &:nth-of-type(1) {
      margin-bottom: 4px;
    }

    &:nth-of-type(2) {
      margin-bottom: 8px;
    }

    &:nth-of-type(3) {
      margin-bottom: 16px;
    }
  }
`;

export const ButtonWrapper = styled.a`
  background-color: transparent;
  display: flex;
  width: max-content;
  height: 40px;
  border-radius: 4px;
  gap: 4px;
  padding: 0 16px;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;

  > span {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: #5b36f2;
  }

  &:hover {
    background-color: #e2dffd;
  }

  &:focus-visible,
  &:active {
    background-color: #c6c0fc;
  }
`;
